import { Lightbulb } from "lucide-react";
import { ejemploDe, type CampoId } from "@/examples/textos";

/** "Ej.: Henry puso…" en una línea discreta. */
export function Ejemplo({ campo }: { campo: CampoId }) {
  const e = ejemploDe(campo);
  return (
    <p className="flex items-start gap-1.5 text-sm text-tinta-suave">
      <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-navy" aria-hidden />
      <span><span className="font-medium text-tinta">Ej. {e.quien}:</span> {e.texto}</span>
    </p>
  );
}
